{
  "formRows": [
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "fromDate",
            "displayLabel": "From",
            "required": true,
            "fieldInfo": {
              "dataType": "datetime-local",
              "defaultToCurrentDate": true
            },
            "validators": [
              {
                "type": "required",
                "message": "From date is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "toDate",
            "displayLabel": "To",
            "required": true,
            "fieldInfo": {
              "dataType": "datetime-local"
            },
            "validators": [
              {
                "type": "required",
                "message": "To date is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "accountHolder",
            "displayLabel": "Account Holder",
            "required": true,
            "placeHolder": "Enter Account Holder",
            "returnRawValue": true,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": ["true"]
                  }
                ],
                "limit": 10,
                "orderBy": {"modifiedDate": "asc"},
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "code",
                    "header": "Code"
                  },
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Account holder is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "cycle",
            "displayLabel": "Cycle",
            "required": true,
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Import",
                  "value": "IMPORT"
                },
                {
                  "label": "Export",
                  "value": "EXPORT"
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Cycle is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "active",
            "displayLabel": "Active",
            "required": true,
            "defaultValue": true,
            "fieldInfo": {
              "dataType": "boolean"
            }
          },
          "validators": [
            {
              "type": "required",
              "message": "Status is required"
            }
          ]
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 12"
          },
          "control": {
            "label": "description",
            "displayLabel": "Description",
            "required": true,
            "placeHolder": "Enter Description",
            "fieldInfo": {
              "dataType": "textarea"
            },
            "validators": [
              {
                "type": "required",
                "message": "Description is required"
              }
            ]
          }
        }
      ]
    }
  ]
}
